import { memo } from "react";
import DietCard from "./DietCard";
import client from "helpers/sanity";
import { allDietsQuery, categoryDietsQuery } from "constants/queries";
import React, { useEffect, useState, useCallback, useRef } from "react";
import NoResult from "components/NoResult";

const DietList = ({ category }) => {
  const [page, setPage] = useState(1);
  const [diets, setDiets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef();

  useEffect(() => {
    async function loadMoreDiets() {
      if (!hasMore) return;

      setLoading(true);
      const query = category ? categoryDietsQuery(page) : allDietsQuery(page);

      const newDiets = await client.fetch(query, { category });

      setDiets((prevDiets) => [...prevDiets, ...newDiets]);
      setLoading(false);

      if (newDiets.length === 0) {
        setHasMore(false); // No more data to load
      }
    }

    loadMoreDiets();
  }, [page, category, hasMore]);

  useEffect(() => {
    setPage(1);
    setDiets([]);
    setHasMore(true);
  }, [category]);

  const lastElementRef = useCallback(
    (node) => {
      if (loading || !hasMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  if(!loading && diets.length === 0) return <NoResult />

  return (
    <div className="flex flex-wrap justify-center my-[2rem] w-full max-w-[1280px] m-auto">
      {diets.map((diet, index) => (
        <div
          key={index}
          className="w-1/2 sm:max-w-auto md:w-1/3 lg:w-1/4 xl:w-1/5"
        >
          <DietCard data={diet} />
        </div>
      ))}
      <div ref={lastElementRef} className="loading-element">
        {loading && <p>Loading more diets...</p>}
      </div>
    </div>
  );
};

export default memo(DietList);
